// Shared event-tick marker rendering for the vis-timeline dashboards. A tick is a downward
// (inverted) blue triangle; when it represents more than one event the total is drawn in its upper
// third. `kind` tints the triangle so note-only and note+event days read distinctly from plain
// file/comment days (see the .pt-tick-* CSS in EventTooltip).

// What a marker's day-cluster contains, which drives its color:
//   • 'event' — only files/comments (standard light-blue triangle)
//   • 'note'  — only notes (darker-blue triangle)
//   • 'both'  — notes plus files/comments (light-blue triangle outlined in the darker blue)
export type TickKind = 'event' | 'note' | 'both';

export const tickKind = (noteCount: number, otherCount: number): TickKind =>
    noteCount > 0 && otherCount > 0 ? 'both' : noteCount > 0 ? 'note' : 'event';

export const eventTriangleHtml = (total: number, kind: TickKind = 'event'): string => {
    const count = total > 1
        ? `<text x="10" y="7.2" text-anchor="middle" dominant-baseline="middle" class="pt-tri-count">${total}</text>`
        : '';
    const kindClass = kind === 'note' ? ' pt-tick-note' : kind === 'both' ? ' pt-tick-both' : '';
    return `<span class="pt-tick-tri${kindClass}"><svg width="20" height="18" viewBox="0 0 20 18">`
        + `<polygon points="0,0 20,0 10,18" />${count}</svg></span>`;
};
